const CRITICAL_PERCENT = 10;
const LOW_PERCENT = 30;
const CRITICAL_COLOR = '#FD7979';
const LOW_COLOR = '#FFDC40';

/**
 * Returns the lifebar fill color for a given balance percentage, or null when
 * the default green should be used.
 *
 * - <=10% → critical red (#FD7979)
 * - <=30% → low yellow (#FFDC40)
 * - >30%  → null (caller falls back to the default class)
 */
export const getLifebarColor = (percent: number): string | null => {
  if (percent <= CRITICAL_PERCENT) return CRITICAL_COLOR;
  if (percent <= LOW_PERCENT) return LOW_COLOR;
  return null;
};
